<template>
  <div class="mian">
    <div class="setting-main" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="salaryNotice space-between">
        <span class='title1'>工资条设置</span>
        <!-- <el-link type="primary" style="fontweight: 600" @click="sevrUpdate">保存修改</el-link> -->
        <div>
          <!-- <el-link type="primary" style="margin-right:10px">修改</el-link> -->
          <el-link type="primary" style="fontweight: 600" @click="sevrUpdate">保存修改</el-link>
        </div>
      </div>
      <p>
        <span class="title">允许员工访问</span>
        <span class="title-modify">
          <el-switch v-model="userInfo.visible" @change="handleEmployeVisible" active-color="#3BC492"
            inactive-color="#ff4949"></el-switch>
        </span>
      </p>
      <p>
        <span>
          <span class="title" style="margin-right:10px ;">阅后即签
            <el-tooltip class="item" effect="light" content="时间填0，表示阅读后自动签收；时间只支持正整数。设置后请记得点“保存”哦！" placement="bottom">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </span>
          <span class="title">阅读后
            <el-input-number style="width: 105px" :disabled="!signForm.openReaderSign"
              v-model="signForm.openReaderSignHours" size="mini" controls-position="right" :min="0"
              :max="999"></el-input-number>
            小时签收</span>
        </span>
        <span class="title-modify">
          <el-switch v-model="signForm.openReaderSign" active-color="#3BC492" inactive-color="#ff4949"></el-switch>
        </span>
      </p>
    </div>

    <div class="set_user_box">
      <div class="set_user_title">
        <div class="salaryNotice">
          <span class='title1'>通知设置</span>
          <div>
            <i class='el-icon-info'></i>
            <span class='noticeTxt'>使用短信提醒，会扣除短信剩余条数</span>
          </div>
        </div>

        <div>
          <!-- <el-link type="primary" style="margin-right:10px">修改</el-link> -->
          <el-link type="primary" style="fontweight: 600" @click="sevrUpdate">保存修改</el-link>
        </div>
      </div>
      <div class="set_user_contnt">
        <div class="title">未签收</div>
        <el-radio-group v-model="signForm.readAlert" size="mini">
          <el-radio :label="false">不提醒</el-radio>
          <el-radio :label="true">提醒</el-radio>
        </el-radio-group>
        <div>
          <span style="margin-right: 5px; font-size: 14px">发送后</span>
          <el-input-number :disabled="!signForm.readAlert ? true : false" style="width: 80px"
            v-model="signForm.readAlertDays" size="mini" controls-position="right" :min="1" :max="99">
          </el-input-number>
          <span style="margin-left: 5px">天</span>
        </div>
        <div>
          <el-checkbox :disabled="!signForm.readAlert ? true : false" size="mini"
            v-model="signForm.readWxAlert">微信</el-checkbox>
          <el-checkbox :disabled="!signForm.readAlert ? true : false" size="mini"
            v-model="signForm.readSmsAlert">短信</el-checkbox>
          <el-checkbox :disabled="!signForm.readAlert ? true : false" size="mini"
            v-model="signForm.readEmailAlert">邮件</el-checkbox>
        </div>
      </div>
      <div class="set_user_contnt">
        <div class="title">未读</div>
        <el-radio-group v-model="signForm.signAlert" size="mini">
          <el-radio :label="false">不提醒</el-radio>
          <el-radio :label="true">提醒</el-radio>
        </el-radio-group>
        <div>
          <span style="margin-right: 5px; font-size: 14px">发送后</span>
          <el-input-number :disabled="!signForm.signAlert ? true : false" style="width: 80px"
            v-model="signForm.signAlertDays" size="mini" controls-position="right" :min="1" :max="99">
          </el-input-number>
          <span style="margin-left: 5px">天</span>
        </div>
        <div>
          <el-checkbox size="mini" :disabled="!signForm.signAlert ? true : false"
            v-model="signForm.signWxAlert">微信</el-checkbox>
          <el-checkbox size="mini" :disabled="!signForm.signAlert ? true : false"
            v-model="signForm.signSmsAlert">短信</el-checkbox>
          <el-checkbox size="mini" :disabled="!signForm.signAlert ? true : false"
            v-model="signForm.signEmailAlert">邮件</el-checkbox>
        </div>
      </div>
      <!-- <div class="tiText">(使用短信提醒会扣除剩余发送条数)</div> -->
    </div>
    <!--  -->
    <div class="elbox">
      <div class="title1">
        <span>邮件发送模板</span>
        <span class="title-modify" @click="handleModifyTemplate">修改</span>
      </div>
    </div>

    <!-- 模板 -->
    <el-dialog title="修改邮件模板" :visible.sync="templateShow" style="margin-top: -60px" :close-on-click-modal="false"
      v-loading="dialogloading">
      <div class="email-top">
        <p style="font-size: 14px; font-weight: 600; padding-bottom: 10px">
          注：『 』内容请勿修改，否则邮件模板无法正常显示
        </p>
        <el-button @click="emailreset">模板还原</el-button>
      </div>
      <div>
        <edit v-model="richText" :height="'350'"></edit>
        <div class="phoneokbox">
          <el-button @click="templateShow = false">取消</el-button>
          <el-button @click="handleTeplateSave" type="primary">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  changephone,
  emailreset,
  setSaveSettings,
  setServiceInfo,
} from '@/api/setUp.js';
import edit from '@/components/edit';

export default {
  components: {
    edit,
  },
  data() {
    return {
      dialogloading: false,
      userInfo: {
        visible: false,
      },
      signForm: {
        readAlert: false,
        readAlertDays: 1,
        readWxAlert: false,
        readSmsAlert: false,
        readEmailAlert: false,
        signAlert: false,
        signAlertDays: 1,
        signWxAlert: false,
        signSmsAlert: false,
        signEmailAlert: false,
      },
      posId: '',
      adminType: '',
      templateShow: false,
      richText: '',
      loadingBtn: false,
      fullscreenLoading: false,
    }
  },
  created() {
    this.getSetSetting()
    this.getUserInfo()
  },
  methods: {
    async emailreset() {
      let { data } = await emailreset()
      if (data.code == 200) {
        this.$notify({
          title: '成功',
          message: '邮件模板还原成功',
          type: 'success',
        })
        this.loadingBtn = false
        this.richText = ''
        this.templateShow = false
      } else {
        this.$notify({
          title: '失败',
          message: data.msg,
          type: 'error',
        })
      }
      console.log(data)
    },
    async handleTeplateSave() {
      if (this.richText) {
        this.loadingBtn = true
        try {
          let res = await this.$http.post(
            '/salary-service/customer/email/update',
            {
              content: this.richText,
            }
          )
          this.$notify({
            title: '成功',
            message: '邮件模板修改成功',
            type: 'success',
          })
          this.loadingBtn = false
          this.richText = ''
          this.templateShow = false
        } catch (e) { }
      } else {
        this.$notify({
          title: '提示',
          message: '邮件模板内容不能为空！',
          type: 'error',
        });
        return;
      }
    },
    async handleModifyTemplate() {
      this.templateShow = true
      try {
        let res = await this.$http.get(`/salary-service/customer/getEmail`)
        console.log(res.data, '右键')
        this.richText = res.data.content
      } catch (e) { }
    },
    getUserInfo() {
      this.$http.get('authority-center/common/user/info').then((res) => {
        this.posId = res.data.orgId
        this.adminType = res.data.admin
        const username = res.data.username
        console.log(this.posId)
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data
          this.userInfo.username = username
          if (this.userInfo.visible === null) {
            this.userInfo.visible = true
          }
        })
      })
    },
    async handleEmployeVisible(val) {
      if (val) {
        this.$http
          .post('authority-center/open/updateCustomerInfo', {
            ...this.userInfo,
            ...{ fullName: this.userInfo.contact, id: this.posId },
          })
          .then((res) => {
            if (res.data.code == 200) {
              // this.$notify({
              //   title: '成功',
              //   message: '操作成功',
              //   type: 'success',
              // })
              this.getUserInfo()
            }
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        this.$confirm('此操作会让员工不能访问工资条链接, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'el-button--default',
          cancelButtonClass: 'el-button el-button--danger',
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.$http
              .post('authority-center/open/updateCustomerInfo', {
                ...this.userInfo,
                ...{ fullName: this.userInfo.contact, id: this.posId },
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: '成功',
                    message: '操作成功',
                    type: 'success',
                  })
                  this.getUserInfo()
                }
              })
              .catch((e) => {
                console.log(e)
              })
          })
          .catch(() => {
            this.userInfo.visible = true
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    async sevrUpdate() {
      if (this.signForm.readAlert) {
        if (this.signForm.readWxAlert || this.signForm.readSmsAlert || this.signForm.readEmailAlert) {
        } else {
          this.$notify({
            title: '提示',
            message: '您已开启未签收通知提醒，请至少选择一种提醒方式',
            type: 'info',
          })
          return 0
        }
      }
      if (this.signForm.signAlert) {
        if (this.signForm.signWxAlert || this.signForm.signSmsAlert || this.signForm.signEmailAlert) {
        } else {
          this.$notify({
            title: '提示',
            message: '您已开启未读收通知提醒，请至少选择一种提醒方式',
            type: 'info',
          })
          return 0
        }
      }
      const res = await setSaveSettings(this.signForm)
      if (res.data.code == 200) {
        this.$notify({
          title: '成功',
          message: '保存成功',
          type: 'success',
        })
      }
      this.getSetSetting()
    },
    getSetSetting() {
      this.$http.get(`salary-service/common/settings`).then((res) => {
        this.signForm = res.data

      })
    },
  },
}
</script>

<style lang="less" scoped>
.mian {
  margin: 10px 10px 0;
  background: #fff;
  width: calc(100vw - 220px);
  height: calc(100vh - 81px);
  border-radius: 8px;
  overflow: hidden;
  padding-left: 15px;
}

.setting-main {
  width: 700px;
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  margin: 20px 0 15px 0;

  h4 {
    font-size: 18px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
  }

  p {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(44, 45, 58, 1);
    line-height: 36px;
    height: 36px;
  }
}

.title-modify {
  color: #3bc492;
  float: right;
  font-size: 14px;
  line-height: 27px;
  cursor: pointer;
  font-weight: normal;
}

.set_user_box {
  width: 700px;
  padding: 20px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  .tiText {
    margin-top: 10px;
    color: #ccc;
    text-align: right;
  }

  .set_user_title {
    display: flex;
    justify-content: space-between;
  }

  .set_user_contnt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;

    .title {
      width: 48px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2c2d3a;
      line-height: 22px;
    }
  }
}

.elbox {
  width: 700px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  margin: 15px 0;
}

.title1 {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2c2d3a;
  line-height: 28px;
}

.salaryNotice {
  display: flex;
  align-items: center;
  justify-content: left;

  .title1 {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2c2d3a;
    line-height: 28px;
  }

  i {
    font-size: 14px;
    color: #d2d2d3;
    margin: 0 8px;
    line-height: 0;
  }

  .noticeTxt {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff6161;
    line-height: 20px;
  }
}

.space-between {
  justify-content: space-between;
  margin-bottom: 7px;
}

.phoneokbox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.email-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

/deep/ .el-dialog__body {
  padding: 10px 20px 20px !important;
}
</style>
